"use strict";
var $ = require("../internals/export");
var isDisjointFrom = require("../internals/set-is-disjoint-from");
var setMethodAcceptSetLike = require("../internals/set-method-accept-set-like");
var INCORRECT = !setMethodAcceptSetLike("isDisjointFrom", function(result) {
  return !result;
});
$({ target: "Set", proto: true, real: true, forced: INCORRECT }, {
  isDisjointFrom
});
